// extracted by mini-css-extract-plugin
export default {"profileSuggestions":"ProfileSuggestions_profileSuggestions__2Drzh","profileSuggestionsTitle":"ProfileSuggestions_profileSuggestionsTitle__y7ZDo"};